module.exports = __webpack_public_path__ + "assets/img/logo-3e1f87d3.png";